<template lang="pug">
  .premium
    loading(:active.sync="loading")
    .premium-false(v-if="premium == false && loading == false")
      h1 Going Premium
      p Please see below regarding getting started with Premium.
      br
      p
        strong You have two options regarding premium, you can either specifically get the COVID-19 employer support documents or you can get general premium which contains all documents.
      br
      h2 Option One
      p General Premium
      hr
      .contain-boxes
        .feature-box
          .title
            h2 Initial Payment
          .content
            p To begin, you will need to pay an upfront fee of 
              strong £750.00 ex VAT
        .feature-box.cyan
          .title
            h2 Continued Subscription
          .content
            p You then only need to pay 
              strong £5.00 ex VAT 
              | monthly to continue to use our services and documents.
        .feature-box.gray
          .title
            h2 Get Started
          .content
            p Are you ready to get started? Please click below.
              Button(@click.native="checkout(1)" type="secondary center") Payment #1
      h2 Option Two
      p COVID-19 - Employer Support
      .contain-boxes
        .feature-box
          .title
            h2 One-Time Payment
          .content
            p To begin, you will need to pay an upfront fee of 
              strong £150.00 ex VAT
        .feature-box.gray
          .title
            h2 Get Started
          .content
            p Are you ready to get started? Please click below.
              Button(@click.native="checkout(2)" type="secondary center") Payment #2
    .premium-true(v-else)
      h2 You are Premium!
      p Your payment has been confirmed. Thank you for your purchase.
      .feature-box.payment(v-if="payment.id !== undefined")
        .title
          h2 Latest Payment Reference
        .content
          p If you need a record of your latest payment, please see below:
          hr
          table.payment-ref-table
            tr(v-for="d in Object.keys(payment)")
              td.column {{ $t('fields.' + d) }}
              td(v-if="payment[d] == 'initial'") {{ $t('fields.' + payment[d]) }}
              td(v-else) {{ payment[d] }}
</template>

<script>
import AuthService from '@/services/auth.js'
import PaymentService from '@/services/payment.js'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  data: function() {
    return {
      premium: false,
      loading: true,
      payment: [],
      stripe: null
    }
  },
  components: { Loading },
  mounted: function () {
    var self = this;
    self.stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC);
    this.checkPremium();
  },
  methods: {
    async checkPremium() {
      try {
        const response = await AuthService.is_premium();
        this.loading = true;

        if(response) {
          console.log(response);
          const is_premium = (response.data === true ? true : false);
          this.$store.dispatch('setPremium', is_premium)
          this.premium = is_premium;

          if(is_premium == true)
            this.get_latest_payment();
          
          this.loading = false;

          return is_premium;
        } else {
          this.loading = false;
          return false;
        }
        
      } catch(error) {
        console.log('could not check premium due to an error.')
        console.log(error);
      } 
    },

    async get_latest_payment() {
      let item = this;
      try {
        item.loading = true;
        const response = await PaymentService.get_my_latest();

        if(response) {
          console.log('/// get_latest_payment');
          console.log(response.data);
          item.payment = response.data;
          item.loading = false;
        } else {
          console.log('/// get_latest_payment, no response..');
          console.log(response.data);
          item.loading = false;
        }
        
      } catch(error) {
        console.log(error);
        item.loading = false;
        if(error.response === undefined)
          return item.error = 'Could not get request.';
      } 
    },

    checkout: function(type) {
      console.log('checked called, type: ' + type)
      let user_data = this.$store.state.user;
      let the_sku = process.env['VUE_APP_STRIPE_SKU_' + type];
      console.log(the_sku);
      console.log(process.env.VUE_APP_STRIPE_SKU_1);
      this.stripe.redirectToCheckout({
        customerEmail: user_data.email,
        items: [{
          sku: the_sku,
          quantity: 1
        }],
        successUrl: process.env.VUE_APP_FRONTEND_HOST + '/premium/success',
        cancelUrl: process.env.VUE_APP_FRONTEND_HOST + '/premium/cancel',
      })
      .then(function (result) {
        if (result.error) {
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer.
          // var displayError = document.getElementById('error-message');
          // displayError.textContent = result.error.message;
          console.log(result.error);
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  .premium {
    h1 {
      margin-bottom:14px;
      font-size:24px;
    }
    hr {
      margin: 24px 0px;
    }
    .premium-false {
      padding-top:50px;
    }
  }
  .contain-boxes {
    width:100%;
    float:left;
    margin-bottom:15px;
  }
  .feature-box {
    max-width:250px;
    float:left;
    margin-right:24px;
    background:#eee;
    &.payment {
      max-width:510px;
      width:95%;
    }
    .payment-ref-table {
      .column {
        text-indent:16px;
        font-weight:600;
      }
      td,tr {
        font-size:14px;
        padding:0;
        line-height:36px;
      }
    }
    .title {
      // border-top-right-radius: 8px;
      // border-top-left-radius: 8px;
      background:$primary;
      line-height:55px;
      h2 {
        font-size:16px;
        color:#fff;
        margin-left:18px;
      }
    }
    &.cyan {
      .title {
        background: #2eae95;
      }
    }
    &.gray {
      .title {
        background: #515151;
      }
    }
    .content {
      padding:24px;
      background:#eee;
      box-shadow: 0 22px 15px -22px #000;
    }
  }
</style>